import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';
import { useIntlCurrency } from 'src/util/i18n/currency';
import { valuePerUnitWithStrong } from 'src/util/i18n/energyPrice';

/**
 * Description
 * @param {object} props
 * @returns {React.ReactElement} - AdminTariffShowVolumeCharge component
 */
function AdminTariffShowVolumeCharge(props) {
  if (!props) {
    return <tr><td aria-label="loading" colSpan={6}><Loading /></td></tr>;
  }
  const intl = useIntl();
  const intlCurrency = useIntlCurrency();

  const { volumeCharge } = props;
  const {
    id, identifier, externalIdentifier, title,
    rate, importFlag, exportFlag, ignorePublicHolidays,
  } = volumeCharge;

  const importFlagLabel = intl.formatMessage({
    id: 'components.admin.admin_tariff.admin_tariff_show.admin_tariff_show_volume_charge.import.label',
    defaultMessage: 'Import',
  });

  const exportFlagLabel = intl.formatMessage({
    id: 'components.admin.admin_tariff.admin_tariff_show.admin_tariff_show_volume_charge.export.label',
    defaultMessage: 'Export',
  });

  const ignorePublicHolidaysFlagLabel = intl.formatMessage({
    id: 'components.admin.admin_tariff.admin_tariff_show.admin_tariff_show_volume_charge.ignore_public_holidays.label',
    defaultMessage: 'Ignore public holidays',
  });

  return (
    <tr key={`tariff-volume-charge-${id}`}>
      <th scope="row" colSpan={2}>
        <Link to={`/admin/volume-charges/${id}`}>
          {title}
        </Link>
        <br />
        {identifier}
      </th>
      <td colSpan={2}>
        <UUID uuid={id} />
        <br />
        {externalIdentifier}
      </td>
      <td>
        {valuePerUnitWithStrong(intl, intlCurrency, rate)}
      </td>
      <td>
        {importFlag && <div>{importFlagLabel}</div>}
        {exportFlag && <div>{exportFlagLabel}</div>}
        {ignorePublicHolidays && <div>{ignorePublicHolidaysFlagLabel}</div>}
      </td>
    </tr>
  );
}

AdminTariffShowVolumeCharge.propTypes = {
  volumeCharge: PropTypes.shape({
    id: PropTypes.string,
    identifier: PropTypes.string,
    externalIdentifier: PropTypes.string,
    title: PropTypes.string,
    rate: PropTypes.number,
    importFlag: PropTypes.bool,
    exportFlag: PropTypes.bool,
    ignorePublicHolidays: PropTypes.bool,
  }),
};

AdminTariffShowVolumeCharge.defaultProps = {
  volumeCharge: null,
};

export default AdminTariffShowVolumeCharge;
